import React from "react";

/**
 * Logo: anatomical spinal column (S-curve) with vertebrae stack.
 * Variants: 'color' | 'white' (keeps orange container, white text/spine for dark backgrounds)
 */
export default function Logo({ className = "h-10 w-auto", variant = "color", showText = true }) {
  const isWhite = variant === "white";
  const containerFill = "#EA580C"; // orange always
  const dark = isWhite ? "#FFFFFF" : "#1C1917";
  const accent = isWhite ? "rgba(255,255,255,0.75)" : "#0F766E";

  return (
    <svg viewBox="0 0 280 64" className={className} xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMid meet" aria-label="Osvaldo Alves - Quiropraxia em Cabo Frio">
      {/* Anatomical spine in a soft rounded square */}
      <g transform="translate(2,4)">
        <rect x="0" y="0" width="56" height="56" rx="16" fill={containerFill} />

        <g transform="translate(28,8)" fill="none" stroke="white" strokeWidth="0.6" strokeLinecap="round">
          <g fill="white">
            <path d="M -3.5 1 Q 0 -0.5 3 1 L 3 3 Q 0 4 -3 3 Z" opacity="0.95" />
          </g>
          <g transform="translate(0.5,5.5)" fill="white">
            <path d="M -4 0.8 Q 0 -1 4 0.8 L 4 3 Q 0 4.2 -4 3 Z" opacity="0.95" />
          </g>
          <g transform="translate(1.5,10.5)" fill="white">
            <path d="M -4.5 0.8 Q 0 -1.2 4.5 0.8 L 4.5 3.2 Q 0 4.5 -4.5 3.2 Z" opacity="0.95" />
            <path d="M -4.5 2 Q -7 3 -8.5 5" stroke="white" strokeWidth="0.6" fill="none" opacity="0.5" />
            <path d="M 4.5 2 Q 7 3 8.5 5" stroke="white" strokeWidth="0.6" fill="none" opacity="0.5" />
          </g>
          <g transform="translate(2,15.5)" fill="white">
            <path d="M -5 0.8 Q 0 -1.2 5 0.8 L 5 3.4 Q 0 4.7 -5 3.4 Z" opacity="0.95" />
            <path d="M -5 2 Q -8 3.5 -10 6" stroke="white" strokeWidth="0.6" fill="none" opacity="0.45" />
            <path d="M 5 2 Q 8 3.5 10 6" stroke="white" strokeWidth="0.6" fill="none" opacity="0.45" />
          </g>
          <g transform="translate(1.5,20.5)" fill="white">
            <path d="M -5.2 0.8 Q 0 -1.2 5.2 0.8 L 5.2 3.4 Q 0 4.7 -5.2 3.4 Z" opacity="0.95" />
          </g>
          <g transform="translate(0.5,25.8)" fill="white">
            <path d="M -5.5 0.9 Q 0 -1.3 5.5 0.9 L 5.5 3.6 Q 0 4.9 -5.5 3.6 Z" opacity="0.95" />
          </g>
          <g transform="translate(-0.8,31.4)" fill="white">
            <path d="M -5.6 1 Q 0 -1.3 5.6 1 L 5.6 3.7 Q 0 5 -5.6 3.7 Z" opacity="0.95" />
          </g>
          <g transform="translate(-2,37.5)" fill="white">
            <path d="M -5 1 L 5 1 L 3.2 6 L -3.2 6 Z" opacity="0.95" />
          </g>
        </g>
      </g>

      {showText && (
        <g transform="translate(68,0)" fontFamily="Outfit, sans-serif">
          <text x="0" y="30" fontSize="22" fontWeight="800" fill={dark} letterSpacing="-0.5">
            Osvaldo Alves
          </text>
          <text x="0" y="48" fontSize="9" fontWeight="700" letterSpacing="2.4" fill={accent}>
            QUIROPRAXIA · CABO FRIO
          </text>
        </g>
      )}
    </svg>
  );
}
